import { DeviceTaskStatusEnum } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

/** A task in one of these statuses is over. */
export const ENDED_TASK_STATUSES = [DeviceTaskStatusEnum.Done, DeviceTaskStatusEnum.Finished];
